import { render, staticRenderFns } from "./GRITable2021Micro.vue?vue&type=template&id=17b787e8&scoped=true"
import script from "./GRITable2021Micro.vue?vue&type=script&lang=js"
export * from "./GRITable2021Micro.vue?vue&type=script&lang=js"
import style0 from "./GRITable2021Micro.vue?vue&type=style&index=0&id=17b787e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b787e8",
  null
  
)

export default component.exports